import { LOADER_VARIANT, StatusType } from '@components/WhatsappChallanNewFlow/enums'
import { QuickScansList } from '@components/WhatsappChallanNewFlow/interfaces'

export const getQuickScans = (
  stateName: string,
  isNonVahanState: boolean,
  isNationalVehicle: boolean
): QuickScansList => {
  const heading = 'Running a quick scan'
  const quickScansList = [
    { title: 'Central government database (Vahan)', status: StatusType.COMPLETE, variant: LOADER_VARIANT.VARIANT_1 },
  ]

  if (isNationalVehicle) {
    quickScansList.push({ title: 'State RTOs', status: StatusType.REQUIRES_APP, variant: LOADER_VARIANT.VARIANT_2 })
    return { quickScansList, heading }
  }

  quickScansList.push({
    title: 'Neighbouring state RTOs',
    status: isNonVahanState ? StatusType.COMPLETE : StatusType.REQUIRES_APP,
    variant: LOADER_VARIANT.VARIANT_2,
  })

  quickScansList.push({
    title: `${stateName} state RTO`,
    status: isNonVahanState ? StatusType.REQUIRES_APP : StatusType.COMPLETE,
    variant: LOADER_VARIANT.VARIANT_3,
  })

  return { quickScansList, heading }
}
